import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AdminFrameComponent } from './frame/admin-frame/admin-frame.component';
import { AdminGuard } from './guards/admin.guard';
import { AccountComponent } from './pages/account/account.component';
import { AccountComponent as AdminAccountComponent } from './pages/admin/account/account.component';
import { AccountsComponent } from './pages/admin/accounts/accounts.component';
import { LicenceTypesComponent } from './pages/admin/licence-types/licence-types.component';
import { LicenceComponent } from './pages/admin/licence/licence.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'accounts', redirectTo: 'admin/accounts', pathMatch: 'full' },
  { path: 'accounts/:perma', component: AccountComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'admin',
    component: AdminFrameComponent,
    canActivate: [
      AdminGuard,
      // AuthGuard,
    ],
    children: [
      { path: 'licence-types', component: LicenceTypesComponent },
      { path: 'accounts', component: AccountsComponent },
      { path: 'accounts/new', component: AdminAccountComponent },
      { path: 'accounts/:perma', component: AdminAccountComponent },
      {
        path: 'accounts/:accountPerma/licences/new',
        component: LicenceComponent,
      },
      {
        path: 'accounts/:accountPerma/licences/:licencePerma',
        component: LicenceComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        enableTracing: false && !environment.production,
        relativeLinkResolution: 'legacy',
      }, // <-- debugging purposes only
      // <-- debugging purposes only
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
